import $ from 'jquery';

function onDocumentReady() {
	$(document).on('click', '.bio-grid-item', onClickBio);
}

function onClickBio(e) {
	const clicked = $(e.currentTarget);

	$.magnificPopup.open({
		items: {
			src: clicked.clone(),
			type: 'inline',
		},
	});
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
